import Joi from "joi";
import { useEffect, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getTrainingCategories,
  getAllTrainingInformation,
  getUserPageBlocks,
} from "../../../../../action/common/commonActionCreator";
import { createTrainingBlock } from "../../../../../action/masters/trainingActionCreator";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import FloatingLabelTextInput from "../../../../../common-components/floatingtextinput";
import MultipleSelect from "../../../../../common-components/multipleSelect";
import { validateFields } from "../../../../../helper/joi-validation";
import {
  getAlertData,
  alertConstants,
} from "../../../../../helper/sweet-alert";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import {
  ICreateTrainingBlock,
  ITrainingBlockCreateData,
} from "../../../../../models/master/training";
import { connect, useDispatch } from "react-redux";
import LoaderSpinner from "../../../../../common-components/loader";
import { masterType } from "../../../../../constants/masterTypes";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { setPageBlocks } from "../../../../../store/slices/common/commonSlice";
import {
  maxImageSize,
  urlRegex,
} from "../../../../../constants/commonConstants";

const CreateTraining = (props: ICreateTrainingBlock) => {
  const {
    createTrainingBlock,
    setShowCreate,
    pageBlocks,
    getAllTrainingBlocks,
    getAllTrainingCategory,
    getAllTrainingKeyValuPairDescritionWithDate,
    trainingCategories,
    trainingKeyValuPairDescritionWithDate,
    getUserPageBlocks,
    userDetails,
  } = props;

  const initialData: ITrainingBlockCreateData = {
    name: "",
    file: null,
    sso: "",
    isActive: true,
    priority: 0,
    pageBlockIds: [],
    description: "",
    collegeId: 0,
    departmentId: 0,
    registrationLink: "",
    isAttendInPerson: true,
    isMandatory: true,
    isOnline: true,
    trainingCategory: 0,
    trainingDate: "",
    endDate: "",
    linkToAttendTraining: "",
    location: "",
  };

  // states

  const [data, setData] = useState(initialData);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageName, setImageName] = useState<string | null | undefined>(null);
  // const ssoOptionsList = Object.entries(booleanOptions).map(([key, value]) => ({
  //   id: value,
  //   name: key,
  // }));
  // const [isSSOEnabled, setIsSSOEnabled] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  // change the data at the time onchange fields
  const onChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    errors && delete errors[event.target.name];
    let _data = { ...data, [event.target.name]: event.target.value };
    if (event.target.type === "radio") {
      if (event.target.id === "isMandatory") {
        _data.isMandatory = true;
      } else if (event.target.id === "isNotMandatory") {
        _data.isMandatory = false;
      }

      if (event.target.id === "isAttendInPerson") {
        _data.isAttendInPerson = true;
      } else if (event.target.id === "isNotAttendInPerson") {
        _data.isAttendInPerson = false;
      }

      if (event.target.id === "isOnline") {
        _data.isOnline = true;
      } else if (event.target.id === "isNotOnline") {
        _data.isOnline = false;
      }
    }

    if (event.target.name === "name") {
      let _item =
        trainingKeyValuPairDescritionWithDate &&
        trainingKeyValuPairDescritionWithDate.find(
          (training) => training.id === event.target.value
        );
      _data.name = _item?.name;
      _data.description = _item?.name ? _item?.description : "";
      _data.trainingDate = _item?.name ? _item?.date : "";
      if (_data.description) errors && delete errors["description"];
      if (_data.trainingDate) errors && delete errors["trainingDate"];
    }

    if (pageBlocks && pageBlocks.length > 0) {
      _data.pageBlockIds = [pageBlocks[0].id];
    }
    setData(_data);
  };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    errors && delete errors[event.target.name];
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setImageName(selectedFile.name.trim().split("/").pop());
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      const validFileTypes = [
        "image/png",
        "image/ico",
        "image/svg+xml",
        "image/x-icon",
      ];
      if (!validFileTypes.includes(fileType)) {
        setErrors({
          ...errors,
          file: "Invalid file type. Please upload an icon.",
        });
      } else if (fileSize > maxImageSize) {
        setErrors({
          ...errors,
          file: "File size exceeds 1MB. Please upload a small file.",
        });
        setImagePreview(null);
        setImageName(null);
      } else {
        setData({ ...data, [event.target.name]: selectedFile });
        const fileURL = URL.createObjectURL(selectedFile);
        setImagePreview(fileURL);
      }
    }
  };

  const schema = Joi.object().keys({
    name: Joi.string().required().label("Select Training Name"),
    file: Joi.object().required().label("File is required"),
    description: Joi.string().required().label("Description is required"),
    linkToAttendTraining: Joi.string().when("isOnline", {
      is: true,
      then: Joi.string().required().regex(urlRegex).label("Enter Valid Link"),
      otherwise: Joi.string().allow("").optional(),
    }),
    trainingCategory: Joi.number()
      .greater(0)
      .required()
      .label("Select Training Category"),
    registrationLink: Joi.string()
      .required()
      .regex(urlRegex)
      .label("Enter Valid Registration Link"),
    location: Joi.string().when("isOnline", {
      is: false,
      then: Joi.string().required().label("Location is required"),
      otherwise: Joi.string().allow("", null).optional(),
    }),
    sso: Joi.string().when("isSSOEnabled", {
      is: true,
      then: Joi.string().required().regex(urlRegex).label("Enter Valid SSO"),
      otherwise: Joi.string().allow("", null).optional(),
    }),
  });

  const validationData = {
    ...data,
    // isSSOEnabled: isSSOEnabled,
  };

  const onSave = async () => {
    const validationErrors = validateFields(validationData, schema);
    if (validationErrors === undefined) {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("file", data.file);
      formData.append("sso", data.sso);
      formData.append("isActive", data.isActive.toString());
      formData.append("isMandatory", data.isMandatory.toString());
      formData.append("isAttendInPerson", data.isAttendInPerson.toString());
      formData.append("trainingDate", data.trainingDate.toString());
      formData.append("endDate", data.endDate ? data.endDate.toString() : "");
      formData.append("linkToAttendTraining", data.linkToAttendTraining);
      formData.append("trainingCategory", data.trainingCategory.toString());
      formData.append("priority", data.priority.toString());
      formData.append(
        "description",
        data.description.replace(/\s+$/g, "").toString()
      );
      formData.append("registrationLink", data.registrationLink);
      formData.append("collegeId", userDetails.currentCollege.id.toString());
      formData.append(
        "departmentId",
        userDetails.currentDepartment.id.toString()
      );
      formData.append("location", data.location ? data.location : "");
      formData.append("isOnline", data.isOnline.toString());
      data.pageBlockIds.map((item, index) => {
        formData.append(`pageBlockIds[${index}]`, item.toString());
      });
      setLoading(true);
      setIsDisabled(true);
      try {
        await createTrainingBlock(formData, setAlert);
      } finally {
        setLoading(false);
        setIsDisabled(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  // setting sweet alert dynamically
  const setAlert = (type: string, name?: string) => {
    let alertData = getAlertData(type, name);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  // executed on clicking 'OK' in sweet alert.
  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else {
      getAllTrainingBlocks();
      setShowCreate(false);
    }
  };

  useEffect(() => {
    getUserPageBlocks(UserTypes.Staff, masterType.training);
    getAllTrainingCategory && getAllTrainingCategory();
    getAllTrainingKeyValuPairDescritionWithDate &&
      getAllTrainingKeyValuPairDescritionWithDate();
    return () => {
      dispatch(setPageBlocks([]));
    };
  }, []);

  const onChangeDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    errors && delete errors[name];
    const updatedData = { ...data, [name]: value };

    // Validate dates
    if (name === "endDate" && value < updatedData.trainingDate) {
      setErrors({
        ...errors,
        endDate: "End date cannot be earlier than the start date.",
      });
    } else if (
      name === "trainingDate" &&
      updatedData.endDate &&
      updatedData.endDate < value
    ) {
      setErrors({ ...errors, endDate: "Please adjust the end date." });
      updatedData.endDate = "";
    }
    setData(updatedData);
  };

  return (
    <>
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
          Add New Training Block
        </h1>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={() => setShowCreate(false)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-6 form-group">
            <FloatingLabelDropDown
              label={"Training Category "}
              onChange={onChange}
              isMandatory={true}
              value={data.trainingCategory}
              name={"trainingCategory"}
              optionsList={sortAlphabetically(trainingCategories)}
            />
            {errors?.trainingCategory && (
              <div className="text-danger">{errors.trainingCategory}</div>
            )}
          </div>
          <div className="col-md-6 form-group">
            <div className="d-flex">
              <label className="profile_details_text">
                Icon<i className="label-asterisk"> * </i>
              </label>
              <p className="ms-2 label-info">
                <i className="fa-solid fa-circle-info"></i>
                <span>
                  Upload an icon (SVG, PNG, or ICO). For best results, use a
                  square shape with a transparent background.
                </span>
              </p>
            </div>
            <div className="inputfile-flex">
              {imagePreview && (
                <div className="inputfile-img">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
              )}
              <div className="inputfile-wrap">
                <input
                  type="file"
                  name="file"
                  id="image"
                  className="form-control d-none"
                  required
                  onChange={onFileChange}
                  accept="image/png, image/svg+xml, image/x-icon, image/ico, .svg, .png, .ico,"
                  value={errors?.file && ""}
                />
                <div className="inputfile">
                  <label htmlFor="image">Choose File</label>
                  <span>{imageName ? imageName : "No File Choosen"}</span>
                </div>
              </div>
            </div>
            {errors?.file && <div className="text-danger">{errors.file}</div>}
          </div>
          <div className="col-md-12 form-group">
            <FloatingLabelDropDown
              label={"Training Name "}
              onChange={onChange}
              isMandatory={true}
              value={data.name}
              name={"name"}
              optionsList={sortAlphabetically(
                trainingKeyValuPairDescritionWithDate
              )}
            />
            {errors?.name && <div className="text-danger">{errors.name}</div>}
          </div>

          <div className="col-md-12 form-group">
            <label className="profile_details_text">
              Training Description <i className="label-asterisk"> * </i>
            </label>
            <textarea
              name="description"
              value={data.description}
              onChange={onChange}
              maxLength={1000}
            ></textarea>
            {errors?.description && (
              <div className="text-danger">{errors.description}</div>
            )}
          </div>

          <div className="col-md-6 form-group">
            <label className="profile_details_text">Mandatory</label>
            <div className="btn-flex pt-2 justify-content-start">
              <div className="btn-group">
                <div className="bch-radio">
                  <input
                    id="isMandatory"
                    type="radio"
                    name="isMandatory"
                    checked={data.isMandatory}
                    onChange={onChange}
                  />
                  <label htmlFor="isMandatory">
                    <span>Yes</span>
                  </label>
                </div>
                <div className="bch-radio">
                  <input
                    id="isNotMandatory"
                    type="radio"
                    name="isMandatory"
                    checked={!data.isMandatory}
                    onChange={onChange}
                  />
                  <label htmlFor="isNotMandatory">
                    <span>No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 form-group">
            <label className="profile_details_text">Attend in Person</label>
            <div className="btn-flex pt-2 justify-content-start">
              <div className="btn-group">
                <div className="bch-radio">
                  <input
                    id="isAttendInPerson"
                    type="radio"
                    name="isAttendInPerson"
                    checked={data.isAttendInPerson}
                    onChange={onChange}
                  />
                  <label htmlFor="isAttendInPerson">
                    <span> Yes</span>
                  </label>
                </div>
                <div className="bch-radio">
                  <input
                    id="isNotAttendInPerson"
                    type="radio"
                    name="isAttendInPerson"
                    checked={!data.isAttendInPerson}
                    onChange={onChange}
                  />
                  <label htmlFor="isNotAttendInPerson">
                    <span>No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 form-group">
            <label className="profile_details_text">Online</label>
            <div className="btn-flex pt-2 justify-content-start">
              <div className="btn-group">
                <div className="bch-radio">
                  <input
                    id="isOnline"
                    type="radio"
                    name="isOnline"
                    checked={data.isOnline}
                    onChange={onChange}
                  />
                  <label htmlFor="isOnline">
                    <span> Yes</span>
                  </label>
                </div>
                <div className="bch-radio">
                  <input
                    id="isNotOnline"
                    type="radio"
                    name="isOnline"
                    checked={!data.isOnline}
                    onChange={onChange}
                  />
                  <label htmlFor="isNotOnline">
                    <span>No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 form-group">
            <label className="profile_details_text">Training Date</label>
            <input
              type="date"
              name="trainingDate"
              className="form-control"
              onChange={onChangeDate}
              value={data.trainingDate}
              min={new Date().toISOString().split("T")[0]}
            />
            {errors?.trainingDate && (
              <div className="text-danger">{errors.trainingDate}</div>
            )}
          </div>
          <div className="col-md-6 form-group">
            <label className="profile_details_text">End Date</label>
            <input
              type="date"
              name="endDate"
              className="form-control"
              onChange={onChangeDate}
              value={data.endDate}
              min={data.trainingDate}
            />
          </div>
          {/* <div className="col-md-6 form-group">
            <FloatingLabelDropDown
              label={"Is SSO Enabled "}
              onChange={(e: any) => setIsSSOEnabled(e.target.value)}
              isMandatory={true}
              value={isSSOEnabled}
              name={"isSSOEnabled"}
              optionsList={ssoOptionsList}
            />
          </div>
          {isSSOEnabled && (
            <div className="col-md-6 form-group">
              <FloatingLabelTextInput
                label={"SSO"}
                onChange={onChange}
                isMandatory={true}
                value={data.sso}
                name={"sso"}
                maxLength={500}
              />
              {errors?.sso && <div className="text-danger">{errors.sso}</div>}
            </div>
          )} */}
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"Link to attend the training"}
              onChange={onChange}
              isMandatory={data.isOnline}
              value={data.linkToAttendTraining}
              name={"linkToAttendTraining"}
              maxLength={500}
              disable={!data.isOnline}
            />
            {errors?.linkToAttendTraining && (
              <div className="text-danger">{errors.linkToAttendTraining}</div>
            )}
          </div>
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"Registration Link"}
              onChange={onChange}
              isMandatory={true}
              value={data.registrationLink}
              name={"registrationLink"}
              maxLength={500}
            />
            {errors?.registrationLink && (
              <div className="text-danger">{errors.registrationLink}</div>
            )}
          </div>

          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"College Name "}
              onChange={onChange}
              isMandatory={true}
              value={userDetails?.currentCollege?.name}
              name={"collegeId"}
              disable
            />
          </div>
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"Department Name "}
              onChange={onChange}
              isMandatory={true}
              value={userDetails?.currentDepartment?.name}
              name={"departmentId"}
              disable
            />
          </div>
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"Page-Block "}
              onChange={onChange}
              isMandatory={false}
              value={pageBlocks[0]?.name}
              name={"pageBlockIds"}
              disable
            />
          </div>
          <div
            // className={
            //   isSSOEnabled === true
            //     ? "col-md-12 form-group"
            //     : "col-md-6 form-group"
            // }
            className="col-md-12 form-group"
          >
            <FloatingLabelTextInput
              label={"Location"}
              onChange={onChange}
              isMandatory={!data.isOnline}
              value={data.location}
              name={"location"}
              disable={data.isOnline}
              maxLength={50}
            />
            {errors?.location && (
              <div className="text-danger">{errors.location}</div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSave}
            disabled={isDisabled}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={() => setShowCreate(false)}
            disabled={isDisabled}
          >
            Close
          </button>
        </div>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
      {loading && <LoaderSpinner />}
    </>
  );
};

const mapDispatchToProps = {
  createTrainingBlock: (data: any, callBack: Function) =>
    createTrainingBlock(data, callBack),
  getAllTrainingCategory: () => getTrainingCategories(),
  getAllTrainingKeyValuPairDescritionWithDate: () =>
    getAllTrainingInformation(),
  getUserPageBlocks: (userType: number, masterType: string) =>
    getUserPageBlocks(userType, masterType),
};

function mapStateToProps(state: any) {
  return {
    pageBlocks: state.common.pageBlocks,
    trainingCategories: state.common.trainingcategories,
    trainingKeyValuPairDescritionWithDate:
      state.common.trainingNameWithDescriptionAndDate,
    userDetails: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTraining);
